/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PegsimileApplication } from './pegsimile-application';

/**
 *
 * @export
 * @interface Pagsmile
 */
export class Pagsmile {
    /**
     *
     * @type {{ [key: string]: PegsimileApplication; }}
     * @memberof Pagsmile
     */
    applications: { [key: string]: PegsimileApplication };
    /**
     *
     * @type {string}
     * @memberof Pagsmile
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Pagsmile
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Pagsmile
     */
    type: string;
    /**
     *
     * @type {boolean}
     * @memberof Pagsmile
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Pagsmile
     */
    autoApprove: boolean;
}
